import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
} from '@mui/material';
import axios from 'axios';
import RuleType from './cleanse-rule-steps/RuleType';
import Configure from './cleanse-rule-steps/Configure';
import { addCleanseRuleByEntityId } from "../../../api's/DataModelApi";

const steps = ['Rule Type', 'Configure'];

const AddRuleModal = ({ open, onClose, onSave, entities, entityName, entityId, attributes }) => {
  const [activeStep, setActiveStep] = useState(0);

  const [formData, setFormData] = useState({
    rule_name: '',
    description: '',
    rule_type: '',
    rule_type_id: '',
    applies_to: [],
    status: true,
    configuration: {
      applies_to: [],
      case_sensitive: false,
      apply_to_nulls: false,
    },
  });

  useEffect(() => {
    if (!open) {
      setActiveStep(0);
      setFormData({
        rule_name: '',
        description: '',
        rule_type: '',
        rule_type_id: '',
        applies_to: [],
        status: true,
        configuration: {
          applies_to: [],
          case_sensitive: false,
          apply_to_nulls: false,
        },
      });
    }
  }, [open]);

  const handleNext = async () => {
    if (activeStep === steps.length - 1) {
      try {
        const response = await addCleanseRuleByEntityId(entityId, formData);
        if (onSave) onSave(response);
        onClose();
      } catch (error) {
        console.error('❌ Error saving rule:', error);
      }
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return <RuleType entities={entities} attributes={attributes} formData={formData} setFormData={setFormData} />;
      case 1:
        return <Configure entityId={entityId} formData={formData} setFormData={setFormData} />;
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          height: '80vh',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DialogTitle>Add Cleanse Rule</DialogTitle>

      <DialogContent dividers>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box mt={3}>{renderStepContent()}</Box>
      </DialogContent>

      <DialogActions>
        {activeStep === 0 && (
          <Button onClick={onClose} color="inherit">
            Cancel
          </Button>
        )}
        {activeStep > 0 && (
          <Button onClick={handleBack} color="inherit">
            Back
          </Button>
        )}
        <Button variant="contained" onClick={handleNext}>
          {activeStep === steps.length - 1 ? 'Save' : 'Next'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddRuleModal;
